import { Component, HostListener, ElementRef } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';// @ts-ignore
import { RecaptchaModule } from 'ng-recaptcha';

@Component({
  selector: 'app-consultancy-solutions',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, NgIf, NgClass, RouterLink, FormsModule, ReactiveFormsModule, RecaptchaModule],
  templateUrl: './consultancy-solutions.component.html',
  styleUrl: './consultancy-solutions.component.scss'
})
export class ConsultancySolutionsComponent {
  patentContent: any;
  InquiryForm: FormGroup = this.fb.group({});

  isMenuOpen = false;
  items1: string[] = [];
  items2: string[] = [];
  items3: string[] = [];
  items4: string[] = [];
  head: any[] = [];
  countries: any[] = [];
  originalCountries: any[] = [];
  formSubmitted = false;
  errorMessage: any;
  alertVisible = false;
  currentPage: string = 'service';
  showPatentService: boolean = true;
  pdfFiles: any[] = [];
  recaptchaResponse: string | null = null;
  recaptchaSiteKey = '6LfvdWgqAAAAAB4irdmbPCmlpmyBzGLjGVIrHE_S'; // live
  // recaptchaSiteKey = '6Lcpo3QqAAAAAIKDJyb4lg4QKCWMuQMA7VxbP9uD'; // local
  currentUrl: string;
  constructor(private datasearch: DatasearchService, private elementRef: ElementRef, private fb: FormBuilder) {
    this.currentUrl = window.location.href; // Get the current URL

  }

  imageBaseUrl = this.datasearch.ApiUrl + '/uploads/images/';
  ngOnInit() {
    this.loadCountryCodes();
    this.initializeForm();
    this.getHeading();
    this.fetchPatentContent();
    this.getPdf();
  }

  loadCountryCodes() {
    const uniqueCountries = new Map();
    getCountries().forEach((country) => {
      const code = `+${getCountryCallingCode(country)}`;
      const flag = `https://flagcdn.com/16x12/${country.toLowerCase()}.png`;
      if (!uniqueCountries.has(code)) {
        uniqueCountries.set(code, { code, flag });
      }
    });
    this.countries = Array.from(uniqueCountries.values());
  }
  initializeForm() {
    this.InquiryForm = this.fb.group({
      name: ['', [Validators.required]],
      number: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
      country_code: ['+91', [Validators.required]],
      query_type: ["patend-inquery"],
      // recaptcha: ['', Validators.required],
    });
  }
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  onCaptchaSuccess(token: string | null) {
    this.recaptchaResponse = token;
  }

  // Reset reCAPTCHA
  resetCaptcha() {
    this.recaptchaResponse = null; // Reset the response manually
  }
  submit_Inquiry_form() {
    this.formSubmitted = true;
    if (this.recaptchaResponse) {
      if (this.InquiryForm.valid) {
        const formDataWithoutRecaptcha = { ...this.InquiryForm.value };
        const postdata = {
          data: {
            ...formDataWithoutRecaptcha,
            date: new Date().toLocaleString()
          }
        };
        this.datasearch.sendInquiryForm(postdata).subscribe(
          (response) => {
            // console.log('Form submitted successfully', response);
            this.errorMessage = '';
            this.alertVisible = true;
            this.InquiryForm.reset();
            this.loadCountryCodes();
            this.formSubmitted = false;
            this.InquiryForm.reset({ country_code: '+91' });
            this.resetCaptcha();
            setTimeout(() => {
              this.alertVisible = false; // Hide the alert after 10 seconds
            }, 10000);
          },
          (error) => {
            console.error('Error submitting form', error);
            this.errorMessage = 'An error occurred while submitting the form. Please try again later.';
          }
        );
      } else {
        this.errorMessage = 'Please fill out all required fields correctly.';
      }
    } else {
      this.errorMessage = 'Please complete the reCAPTCHA verification.';
    }
  }

  fetchPatentContent() {
    this.datasearch.getPatents().subscribe(
      (response: any) => {
        console.log('Patent API Response:', response);
        // Handle both { success: true, data: [...] } and direct [...] formats
        let data = response.data || response;
        if (Array.isArray(data)) {
          this.patentContent = data.map((item: any) => this.mapPatentItem(item));
          this.getPdf();
        } else if (data && typeof data === 'object') {
          // Handle single object response
          this.patentContent = [this.mapPatentItem(data)];
          this.getPdf();
        } else {
          console.error('Unexpected data format from Patent API:', data);
        }
      },
      (error) => {
        console.error('Error fetching patent content:', error);
      }
    );
  }

  private mapPatentItem(item: any) {
    const clearSpaces = (text: string) => {
      if (!text || typeof text !== 'string') return text;
      return text.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
    };

    let lists = item.lists || [];
    let body = item.body || item.sections || [];

    if (item.keyPointsTitle || item.keyPoints) {
      lists.push({
        title: clearSpaces(item.keyPointsTitle || ''),
        keyWords: Array.isArray(item.keyPoints)
          ? item.keyPoints.map((kp: any) => clearSpaces((typeof kp === 'object' && kp !== null) ? kp.point : kp))
          : []
      });
    }

    if (typeof lists === 'string') {
      try { lists = JSON.parse(lists); } catch (e) { lists = []; }
    }
    if (typeof body === 'string') {
      try { body = JSON.parse(body); } catch (e) { body = []; }
    }

    if (Array.isArray(lists)) {
      lists = lists.map((list: any) => ({
        ...list,
        title: clearSpaces(list.title || list.name || list.header || ''),
        keyWords: Array.isArray(list.keyWords || list.keypoints || list.items)
          ? (list.keyWords || list.keypoints || list.items).map((k: any) => clearSpaces(k))
          : []
      }));
    }

    if (Array.isArray(body)) {
      body = body.map((section: any) => ({
        ...section,
        body_title: clearSpaces(section.body_title || section.title || section.name || section.header || ''),
        body_description: clearSpaces(section.body_description || section.description || section.content || ''),
        body_keypoints: Array.isArray(section.body_keypoints || section.keypoints || section.points)
          ? (section.body_keypoints || section.keypoints || section.points).map((p: any) => ({
            ...p,
            pointTitle: clearSpaces(p.pointTitle || p.title || ''),
            pointDescription: clearSpaces(p.pointDescription || p.description || '')
          }))
          : []
      }));
    }

    return {
      ...item,
      lists: lists,
      body: body,
      header_title: clearSpaces(item.header_title || item.title || item.patent_title || 'Patent Service'),
      header_subtitle: clearSpaces(item.header_subtitle || item.subTitle || item.subtitle || item.description_short || ''),
      header_description: clearSpaces(item.header_description || item.description || item.content || ''),
      image: item.image || item.header_image || item.icon || ''
    };
  }

  isString(val: any): boolean {
    return typeof val === 'string';
  }


  getPdf() {
    const baseUrl = this.datasearch.ApiUrl + '/uploads/pdfs/';
    this.datasearch.getPdfs().subscribe(
      (response: any) => {
        if (response.success && Array.isArray(response.data)) {
          this.pdfFiles = response.data.map((pdf: any) => ({
            file_name: pdf.file_name, // Keep this consistent with the template
            url: baseUrl + pdf.pdf // Construct the full PDF URL
          }));
          // console.log(this.pdfFiles); // Verify the data
        } else {
          console.error('No PDF data found or response unsuccessful');
        }
      },
      error => {
        console.error('Error fetching PDF files:', error);
      }
    );
  }

  // Function to extract a cleaner name from the filename
  getFormattedPdfName(fileName: string): string {
    return fileName.replace(/_/g, ' ').replace(/\.[^/.]+$/, '');
  }




  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isMenuOpen = false;
    }
  }
  getHeading() {
    this.datasearch.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
}
